/**
 * @generated SignedSource<<4f84076dda624ae12c2161f7cd2142d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeRoleEditForm_employeeRole$data = {
  readonly employees: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly id: string;
  readonly name: string;
  readonly team: {
    readonly id: string;
  };
  readonly " $fragmentType": "EmployeeRoleEditForm_employeeRole";
};
export type EmployeeRoleEditForm_employeeRole$key = {
  readonly " $data"?: EmployeeRoleEditForm_employeeRole$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmployeeRoleEditForm_employeeRole">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployeeRoleEditForm_employeeRole",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "team",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employees",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    }
  ],
  "type": "EmployeeRole",
  "abstractKey": null
};
})();

(node as any).hash = "fb3e49477f2ae94d6bcf3ffa7bddb2f8";

export default node;
